import React from "react";
import MaskedCurrencyValue from "../../common/MaskedCurrencyValue";

const ProductCard = ({ title, value, icon, maskable = false }) => {
  const isLoadingValue = React.isValidElement(value);

  return (
    <div className="product-card">
      <div className="product-card-content">
        <h3 className="product-card-title">{title}</h3>
        <div className="product-card-value">
          {maskable && !isLoadingValue ? (
            <MaskedCurrencyValue value={value} />
          ) : (
            value
          )}
        </div>
      </div>
      <div className="product-card-icon">
        <img src={icon} alt={title} />
      </div>
    </div>
  );
};

export default ProductCard;
